import { useEffect, useRef, useState } from "react";
/** 주문 상품이 이 개수 이상이면 목록을 처음부터 펼쳐 보여준다 */ const MIN_ORDER_ITEM_COUNT = 3;
/**
 * 주문 상품 목록 펼침 상태
 *
 * 최초 1회만 자동으로 펼치고(hasInitialized), 이후에는 사용자 조작을 따른다.
 */ export const useCheckoutDropDown = (orderItems)=>{
    const [dropDown, setDropDown] = useState(false);
    const hasInitialized = useRef(false);
    useEffect(()=>{
        if (!hasInitialized.current && orderItems.length >= MIN_ORDER_ITEM_COUNT) {
            setDropDown(true);
            hasInitialized.current = true;
        }
    }, [
        orderItems
    ]);
    const handleDropDown = ()=>setDropDown((state)=>!state);
    return {
        dropDown,
        handleDropDown
    };
};
